// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripeContainerFlex_tamlM {
    display: flex;
    gap: 4px;
    span {
      font-size: 13px;
      color: var(--8C90A2-color);
    }
    > div {
      flex: 1 1;
    }
  }
  .stripeContainerFlex_tamlM > div {
    display: flex;
    gap: 10px;
    margin: 10px 0;
    flex-direction: column;
  }

  .stripeContainerFlex_tamlM > div > div {
    flex: 1 1 100%; 
    padding: 6px;
    box-sizing: border-box;
    background-color: var(--f0-border);
  }

  .moreInfoContainer_Favdd{
    background-color: var(--f5-background);
    transition: background-color 0.3s ease;
    border-radius: 999px;
    cursor: pointer;
  }


  .moreInfoContainer_Favdd:hover {
  stroke: var(--e0-border);
  }

  .contentContainer_u219p{
    display: flex
;
    flex-direction: column;
    max-height: 55vh;
    overflow-y: auto;
    background-color: var(--f5-background);
}

.content_t3_lJ{
    background-color: var(--white-background);
    box-sizing: border-box;
    border-radius: 8px;
    width: 95%;
    margin: 10px auto;
    padding: 10px;
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AddPaymethodPopup/AddPaymethodPopup.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR;MACE,eAAe;MACf,0BAA0B;IAC5B;IACA;MACE,SAAO;IACT;EACF;EACA;IACE,aAAa;IACb,SAAS;IACT,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,sCAAsC;IACtC,sCAAsC;IACtC,oBAAoB;IACpB,eAAe;EACjB;;;EAGA;EACA,wBAAwB;EACxB;;EAEA;IACE;AACJ;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf","sourcesContent":[".stripeContainerFlex {\n    display: flex;\n    gap: 4px;\n    span {\n      font-size: 13px;\n      color: var(--8C90A2-color);\n    }\n    > div {\n      flex: 1;\n    }\n  }\n  .stripeContainerFlex > div {\n    display: flex;\n    gap: 10px;\n    margin: 10px 0;\n    flex-direction: column;\n  }\n\n  .stripeContainerFlex > div > div {\n    flex: 1 1 100%; \n    padding: 6px;\n    box-sizing: border-box;\n    background-color: var(--f0-border);\n  }\n\n  .moreInfoContainer{\n    background-color: var(--f5-background);\n    transition: background-color 0.3s ease;\n    border-radius: 999px;\n    cursor: pointer;\n  }\n\n\n  .moreInfoContainer:hover {\n  stroke: var(--e0-border);\n  }\n\n  .contentContainer{\n    display: flex\n;\n    flex-direction: column;\n    max-height: 55vh;\n    overflow-y: auto;\n    background-color: var(--f5-background);\n}\n\n.content{\n    background-color: var(--white-background);\n    box-sizing: border-box;\n    border-radius: 8px;\n    width: 95%;\n    margin: 10px auto;\n    padding: 10px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stripeContainerFlex": `stripeContainerFlex_tamlM`,
	"moreInfoContainer": `moreInfoContainer_Favdd`,
	"contentContainer": `contentContainer_u219p`,
	"content": `content_t3_lJ`
};
export default ___CSS_LOADER_EXPORT___;
